import { render, staticRenderFns } from "./GatLookupEdit.vue?vue&type=template&id=55b219ea&scoped=true"
import script from "./GatLookupEdit.vue?vue&type=script&lang=js"
export * from "./GatLookupEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b219ea",
  null
  
)

export default component.exports